import { ActionColumnLink } from './ColumnsFormatters/ActionColumnLink';
import { ActionColumnOrder } from './ColumnsFormatters/ActionColumnOrder';
import { ActionColumnImput } from './ColumnsFormatters/ActionColumnImput';
import { ActionColumnUpload } from './ColumnsFormatters/ActionColumnUpload';
import { ActionColumnDelete } from './ColumnsFormatters/ActionColumnDelete';
import { ActionColumnDetails } from './ColumnsFormatters/ActionColumnDetails';
import { ActionColumnDowload } from './ColumnsFormatters/ActionColumnDowload';
import { ActionColumnFormat } from '../../utils/ColumnFormatters/ActionColumnFormat';
import { ActionResolutionDownload } from './ColumnsFormatters/ActionResolutionDownload';

export const columnsOrder = (onAdd) => [
	{
		dataField: 'Aprobacion',
		text: 'Para Aprobacion',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnLink,
		formatExtraData: {
			onAdd,
		},
	},
	{
		dataField: 'Concentimiento',
		text: 'Para Concentimiento',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnLink,
		formatExtraData: {
			onAdd,
		},
	},
	{
		dataField: 'AsuntosGenerales',
		text: 'Para Asuntos Generales',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnLink,
		formatExtraData: {
			onAdd,
		},
	},
];

export const itemsOrder = [
	{ Aprobacion: 'Agregar', Concentimiento: 'Agregar', AsuntosGenerales: 'Agregar' },
	{ Aprobacion: 'Agregar', Concentimiento: 'Agregar', AsuntosGenerales: 'Agregar' },
];

export const columnsTopics = (
	onAdd,
	onChangeValue2,
	onFileOffice,
	onFileCard,
	onFilePresentation,
	onFileAdditionalDoc
) => [
	{
		dataField: 'nombreTema',
		text: 'Tema',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnImput,
		formatExtraData: {
			onChangeValue2,
		},
	},
	{
		dataField: 'unidadAdminstrativa',
		text: 'Unidad Adminstrativa',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnImput,
		formatExtraData: {
			onChangeValue2,
		},
	},
	{
		dataField: 'fundamentoLegal',
		text: 'Fundamento Legal',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnImput,
		formatExtraData: {
			onChangeValue2,
		},
	},
	{
		dataField: 'detalleFundamento',
		text: 'Detalle',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnImput,
		formatExtraData: {
			onChangeValue2,
		},
	},
	{
		dataField: 'Oficio',
		text: 'Oficio',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFileOffice,
		},
	},
	{
		dataField: 'Tarjeta',
		text: 'Tarjeta',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFileCard,
		},
	},
	{
		dataField: 'Presentación',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFilePresentation,
		},
	},
	{
		dataField: 'DocumentosAdicionales',
		text: 'Documentos Adicionales',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFileAdditionalDoc,
		},
	},
	{
		dataField: 'AgregarSección',
		text: 'Agregar Sección',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnOrder,
		formatExtraData: {
			onAdd,
		},
	},
];

export const NEW_ORDER_INPUTS = (options) => [
	{
		label: 'Título del tema',
		name: 'nombreTema',
		type: 'text',
	},
	{
		label: 'Dentro de',
		name: 'dentroDe',
		type: 'dropdown',
		options: options,
	},
];

export const EDIT_ORDER_INPUTS = (
	options,
	disabled,
	valOrgan,
	organ = '',
	sectionValidation
) => {
	return organ === 'Asamblea General' && sectionValidation
		? [
				{
					label: 'Título del tema',
					name: 'nombreTema',
					type: 'text',
					column: 12,
					disabled: disabled,
				},
				{
					label: 'Listado de puntos del orden del día',
					name: 'listado',
					type: 'dropdown',
					options: options,
				},

				{
					label: 'Nuevo orden',
					name: 'ordenamiento',
					type: 'text',
					disabled: disabled,
					column: 12,
				},
			]
		: organ === 'Comité de Auditoría' ||
			  organ === 'Comité de Calidad de Vida y de las Viviendas'
			? [
					{
						label: 'Encabezado del punto',
						name: 'titulo',
						type: 'text',
						column: 12,
						disabled: disabled,
					},
					{
						label: 'Título del tema',
						name: 'nombreTema',
						type: 'text',
						column: 12,
						disabled: disabled,
					},
					{
						label: 'Listado de puntos del orden del día',
						name: 'listado',
						type: 'dropdown',
						options: options,
					},
					{
						label: 'Seccion',
						name: 'asunto',
						type: 'dropdown',
						column: 6,
						disabled: disabled,
						options:
							valOrgan === 'G1'
								? [
										{ value: 'AD', text: 'Adicionales' },
										{ value: 'PA', text: 'Para Aprobación' },
										{ value: 'PC', text: 'Para Conocimiento' },
										{ value: 'AC', text: 'Asuntos Generales' },
									]
								: [
										{ value: 'PA', text: 'Para Aprobación' },
										{ value: 'PC', text: 'Para Conocimiento' },
										{ value: 'AC', text: 'Asuntos Generales' },
									],
					},
					{
						label: 'Nuevo orden',
						name: 'ordenamiento',
						type: 'text',
						disabled: disabled,
						column: 6,
					},
				]
			: [
					{
						label: 'Título del tema',
						name: 'nombreTema',
						type: 'text',
						column: 12,
						disabled: disabled,
					},
					{
						label: 'Listado de puntos del orden del día',
						name: 'listado',
						type: 'dropdown',
						options: options,
					},
					{
						label: 'Seccion',
						name: 'asunto',
						type: 'dropdown',
						column: 6,
						disabled: disabled,
						options:
							valOrgan === 'G1'
								? [
										{ value: 'AD', text: 'Adicionales' },
										{ value: 'PA', text: 'Para Aprobación' },
										{ value: 'PC', text: 'Para Conocimiento' },
										{ value: 'AC', text: 'Asuntos Generales' },
									]
								: sectionValidation === false && valOrgan === 'G2'
									? [
											{ value: 'AD', text: 'Adicionales' },
											{ value: 'PA', text: 'Para Aprobación' },
											{ value: 'PC', text: 'Para Conocimiento' },
											{ value: 'AC', text: 'Asuntos Generales' },
										]
									: valOrgan === 'G3'
										? [
												{ value: 'PA', text: 'Para aprobación' },
												{
													value: 'DO',
													text: 'Dictámenes y opiniones',
												},
												{
													value: 'PC',
													text: 'Para conocimiento',
												},
											]
										: [
												{ value: 'PA', text: 'Para Aprobación' },
												{
													value: 'PC',
													text: 'Para Conocimiento',
												},
												{
													value: 'AC',
													text: 'Asuntos Generales',
												},
											],
					},
					{
						label: 'Nuevo orden',
						name: 'ordenamiento',
						type: 'text',
						disabled: disabled,
						column: 6,
					},
				];
};

export const COLUMNS_RESOLUTIONS_PREVIEW = (onDownload = '') => [
	{
		dataField: 'id',
		text: 'id',
	},
	{
		dataField: 'numeroSesion',
		text: 'No.',
	},
	{
		dataField: 'numeroResolucion',
		text: 'Resolución',
	},
	{
		dataField: 'tipoTema',
		text: 'Tipo',
	},
	{
		dataField: 'texto',
		text: 'Texto',
	},
	{
		dataField: 'nombreOrgano',
		text: 'Órgano Colegiado',
	},
	{
		dataField: 'fechaLimite',
		text: 'Fecha limite de cumplimiento',
	},
	{
		dataField: 'oficio',
		text: 'Oficio    ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'tarjeta',
		text: 'Tarjeta   ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'presentacion',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'adicional',
		text: 'Adicionales',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
];
export const COLUMNS_TEMAS_PREVIEW = (onDownload = '') => [
	{
		dataField: 'id',
		text: 'id',
	},
	{
		dataField: 'nombreTema',
		text: 'Nombre Tema.',
	},

	{
		dataField: 'fundamentoLegal',
		text: 'Fundamento Legal',
	},
	{
		dataField: 'tipo',
		text: 'Tipo Tema',
	},
	{
		dataField: 'oficio',
		text: 'Oficio    ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'tarjeta',
		text: 'Tarjeta   ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'presentacion',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'adicional',
		text: 'Adicionales',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
];
export const COLUMN_RESOLUTIONS_DETAIL = (onDownload = '') => [
	{
		dataField: 'id',
		text: 'ID',
		classes: 'text-center',
		headerClasses: 'text-center',
	},
	{
		dataField: 'tipoTema',
		text: 'Tipo',
		classes: 'text-center',
		headerClasses: 'text-center',
	},
	{
		dataField: 'texto',
		text: 'Tema',
		classes: 'text-center',
		headerClasses: 'text-center',
	},
	{
		dataField: 'asunto',
		text: 'Asunto',
		classes: 'text-center',
		headerClasses: 'text-center',
	},
	{
		dataField: 'oficio',
		text: 'Oficio    ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'tarjeta',
		text: 'Tarjeta   ',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'presentacion',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'adicional',
		text: 'Adicionales',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionResolutionDownload,
		formatExtraData: {
			onDownload,
		},
	},
];

export const columnsResolutions = (onAdd, onFile) => [
	{
		dataField: 'id',
		text: 'id',
	},
	{
		dataField: 'numeroSesion',
		text: 'No.',
	},
	{
		dataField: 'numeroResolucion',
		text: 'Resolución',
	},
	{
		dataField: 'fundamentoJuridico',
		text: 'Legal',
	},
	{
		dataField: 'texto',
		text: 'Texto',
	},
	{
		dataField: 'nombreOrgano',
		text: 'Órgano Colegiado',
	},
	{
		dataField: 'fechaLimite',
		text: 'Fecha limite de cumplimiento',
	},
	{
		dataField: 'Oficio',
		text: 'Oficio',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFile,
		},
	},
	{
		dataField: 'Tarjeta',
		text: 'Tarjeta',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFile,
		},
	},
	{
		dataField: 'Presentación',
		text: 'Presentación',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFile,
		},
	},
	{
		dataField: 'AgregarSección',
		text: 'Agregar Sección',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnOrder,
		formatExtraData: {
			onAdd,
		},
	},
];

export const itemsTopics = [
	{
		Tema2: 'tema22',
		UnidadAdminstrativa2: 'Unidad',
		FundamentoLegal2: 'Fundamento',
		Detalle2: 'Detalle',
	},
];

export const itemsTopicsNUll = [
	{
		Tema: '',
		UnidadAdminstrativa: '',
		FundamentoLegal: '',
		Detalle: '',
		Oficio: '',
		Targeta: '',
	},
];
export const itemsResolutions = [
	{
		No: 'No.',
		Resolución: 'Resolución',
		Legal: 'Legal',
		Detalle: 'Detalle',
		Texto: 'Texto',
		ÓrganoColegiado: 'Órgano',
		Fecha: '26/11/22',
	},
];

export const defaultDocument = {
	counsel: '',
	name: '',
	format: '',
};

export const issueForm = [
	{
		label: 'Nombre',
		name: 'name',
		// labelPos: "start",
		type: 'text',
	},
	{
		label: 'Órgano Colegiado',
		name: 'collegiatebody',
		type: 'dropdown',
		// labelPos: "start",
		options: [
			{ value: 'person 1', text: 'Órgano Colegiado 1' },
			{ value: 'person 2', text: 'Órgano Colegiado 2' },
			{ value: 'person 3', text: 'Órgano Colegiado 3' },
		],
	},
];

export const initialContentForm = [
	{
		label: 'Titulo',
		name: 'title',
		// labelPos: "start",
		type: 'text',
	},
	{
		label: 'Presentador',
		name: 'presenter',
		// labelPos: "start",
		type: 'text',
	},
	{
		label: 'Categorias',
		name: 'categories',
		type: 'dropdown',
		// labelPos: "start",
		options: [
			{ value: '1', text: 'Categoria 1' },
			{ value: '2', text: 'Categoria 2' },
			{ value: '3', text: 'Categoria 3' },
		],
	},
	{
		label: 'Duracion',
		name: 'duration',
		// labelPos: "start",
		type: 'text',
	},
];

///-----------------Add order---------------------------------------------
export const labelsAddOrder = (disabled) => [
	{
		label: 'Número de resolución',
		name: 'SesiOnExtraordinaria',
		type: 'text',
		column: 6,
		disabled: disabled,
	},
	{
		label: 'Nombre de tema',
		name: 'SesiOnExtraordinaria',
		type: 'text',
		column: 6,
		disabled: disabled,
	},
	{
		label: 'Fundamento Legal',
		name: 'SesiOnExtraordinaria',
		type: 'text',
		column: 6,
		disabled: disabled,
	},
];

export const buttons = (disabled, onSave) => [
	{
		title: 'Vista Previa',
		color: 'light-warning',
		onClick: '',
		className: 'mt-lg-15 ml-lg-2',
		disabled: disabled,
	},
	{
		title: 'Descargar',
		color: 'light-info',
		onClick: '',
		className: 'mt-lg-15 ml-lg-2 ',
		disabled: disabled,
	},
	{
		title: 'Editar',
		color: 'light-success',
		onClick: '',
		className: 'mt-lg-15 ml-lg-2',
		disabled: disabled,
	},

	{
		title: 'Guardar',
		color: 'light-primary',
		onClick: onSave,
		className: 'mt-lg-15 ml-lg-2 ',
		disabled: disabled,
	},
];

export const optionAccordion1 = [
	{
		name: 'accordion1',
		type: 'dropdown',

		options: [
			{ value: 1, text: 'Para Aprobación' },
			{ value: 2, text: 'Para Conocimiento' },
			{ value: 3, text: 'Asuntos Generales' },
		],
	},
];

export const optionAccordion2 = [
	{
		name: 'accordion2',
		type: 'dropdown',

		options: [
			{ value: 1, text: 'Para Aprobación' },
			{ value: 2, text: 'Para Conocimiento' },
			{ value: 3, text: 'Asuntos Generales' },
		],
	},
];

export const optionAccordion3 = [
	{
		name: 'accordion3',
		type: 'dropdown',

		options: [
			{ value: 1, text: 'Para Aprobación' },
			{ value: 2, text: 'Para Conocimiento' },
			{ value: 3, text: 'Asuntos Generales' },
		],
	},
];
export const defaultAccordion = {
	accordion1: 1,
	accordion2: 2,
	accordion3: 3,
};

export const labelAddOrder = [
	{
		name: 'name',
		type: 'text',
		//column: 12,
	},
];
export const valueAddOrder = {
	name: '',
	type: '',
};

export const formatOrders = (ordersArray, father) => {
	return ordersArray.map((order) => {
		let formatted = {};
		const father_id = father ?? null;
		if (order.hijos.length === 0) {
			formatted['id'] = order.id;
			formatted['name'] = order.nombreTema;
			formatted['subItems'] = [];
			formatted['resolutions'] = order.resoluciones;
			formatted['order'] = order.numeracion;
			formatted['father_id'] = father_id;
			// formatted[
			// 	'usuario'
			// ] = `${order.usuario.nombre} ${order.usuario.apellidoMaterno}`;
			formatted['asunto'] = order.asunto;
			formatted['titulo'] = order?.titulo || '';
			formatted['isMigrated'] = order.migrado;
		} else {
			formatted['id'] = order.id;
			formatted['name'] = order.nombreTema;
			formatted['resolutions'] = order.resoluciones;
			formatted['temas'] = order.temas;
			formatted['order'] = order.numeracion;
			formatted['subItems'] = formatOrders(order.hijos, order.id);
			formatted['titulo'] = order?.titulo || '';
			// formatted[
			// 	'usuario'
			// ] = `${order.usuario.nombre} ${order.usuario.apellidoMaterno}`;
			formatted['asunto'] = order.asunto;
			formatted['isMigrated'] = order.migrado;
		}
		return formatted;
	});
};

export const formatterBodyIntegration = (order, resolutions, temas) => {
	return {
		ordenDia: order,
		resoluciones: resolutions.map((r) => {
			return { id: r };
		}),
		temas: temas.map((r) => {
			return { id: r };
		}),
	};
};

export const filterOrdersByIssue = (list, issue) =>
	list.filter((order) => order.asunto === issue);

export const getIssues = (name) => {
	switch (name) {
		case 'Adicionales':
			return 'AD';
		case 'Dictámenes y opiniones':
			return 'DO';
		case 'Para aprobación':
			return 'PA';
		case 'Para conocimiento':
			return 'PC';
		default:
			return 'AC';
	}
};

export const getIssue = (name) => {
	switch (name) {
		case 'Adicionales':
			return 'AD';
		case 'Dictámenes y opiniones':
			return 'DO';
		case 'PA':
			return 'Para aprobación';
		case 'PC':
			return 'Para conocimiento';
		default:
			return 'Asuntos Generales';
	}
};

////////FILES
export const columnsRecord = (
	onUploadedFile,
	onDownload,
	onDelete,
	onEye,
	canEdit,
	allFiles,
	uniques,
	setLoader
) => [
	{
		dataField: 'nombreOriginal',
		text: 'Archivo',
		classes: 'text-center',
	},
	canEdit === true
		? {
				dataField: 'id',
				text: 'Archivo',
				classes: 'text-center',
				formatter: ActionColumnUpload,
				formatExtraData: {
					onUploadedFile,
					allFiles,
					uniques,
					setLoader,
				},
			}
		: {},
	{
		dataField: 'ruta',
		text: 'Descargar Archivo',
		classes: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'nombreUsuario',
		text: 'Miembro',
		classes: 'text-center',
	},

	{
		dataField: 'fecha',
		text: 'Fecha',
		classes: 'text-center',
	},
	canEdit === true
		? {
				dataField: 'idFile',
				text: 'Eliminar',
				classes: 'text-center',
				formatter: ActionColumnDelete,
				formatExtraData: {
					onDelete,
				},
			}
		: {},
	canEdit === true
		? {
				dataField: 'row',
				text: 'Acciones',
				classes: 'text-center',
				headerClasses: 'text-center',
				formatter: ActionColumnFormat,
				formatExtraData: {
					onEye,
				},
			}
		: {},
];

////////FILES
export const columnsFiles = (onFile) => [
	{
		dataField: 'nombre',
		text: 'Archivo',
	},
	{
		dataField: 'id',
		text: 'Descargar Archivo',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDetails,
		formatExtraData: {
			onFile,
		},
	},
];

//SECCIONES
export const secciones = (forApproval, forKnowledge, generalBusiness, addMatters) => [
	{
		title: 'Para aprobación',
		data: forApproval,
	},
	{
		title: 'Para conocimiento',
		data: forKnowledge,
	},
	{
		title: 'Asuntos generales',
		data: generalBusiness,
	},
];

export const seccionesAux = (forApproval, forKnowledge, generalBusiness, addMatters) => [
	{
		title: 'Para conocimiento',
		data: forKnowledge,
	},
	{
		title: 'Para aprobación',
		data: forApproval,
	},
	{
		title: 'Asuntos generales',
		data: generalBusiness,
	},
];
export const seccionesOrdCA = (
	forApproval,
	forKnowledge,
	generalBusiness,
	addMatters
) => [
	{
		title: 'Adicionales',
		data: addMatters,
	},
	{
		title: 'Para aprobación',
		data: forApproval,
	},
	{
		title: 'Para conocimiento',
		data: forKnowledge,
	},
	{
		title: 'Asuntos generales',
		data: generalBusiness,
	},
];
export const seccionesOrdAudi = (forApproval, forKnowledge, addMatters, opinions) => [
	{
		title: 'Adicionales',
		data: addMatters,
	},
	{
		title: 'Para aprobación',
		data: forApproval,
	},
	{
		title: 'Dictámenes y opiniones',
		data: opinions,
	},

	{
		title: 'Para conocimiento',
		data: forKnowledge,
	},
];
export const seccionesOrdVigilancia = (forApproval, forKnowledge, opinions) => [
	{
		title: 'Para aprobación',
		data: forApproval,
	},
	{
		title: 'Dictámenes y opiniones',
		data: opinions,
	},
	{
		title: 'Para conocimiento',
		data: forKnowledge,
	},
];

export const seccionesAsamblea = (forApproval) => [
	{
		title: 'Agregar nuevo punto',
		data: forApproval,
	},
];
